import { render, staticRenderFns } from "./LongAnswerField.vue?vue&type=template&id=fee2c60c&"
import script from "./LongAnswerField.vue?vue&type=script&lang=ts&"
export * from "./LongAnswerField.vue?vue&type=script&lang=ts&"
import style0 from "./LongAnswerField.vue?vue&type=style&index=0&id=fee2c60c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports